"use client";

import type { LineItemFragment } from "@commerce-frontend/types";
import type { Dispatch, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";

type AddToCartState = {
	addedLineItem?: LineItemFragment;
	setAddedLineItem: Dispatch<SetStateAction<LineItemFragment | undefined>>;
	errorIsOpen: boolean;
	setErrorOpen: (open: boolean) => void;
};

export const AddToCartContext = createContext<AddToCartState>({
	setAddedLineItem: () => {},
	errorIsOpen: false,
	setErrorOpen: () => {},
});

export const AddToCartProvider = ({
	children,
	initialState,
}: {
	children: React.ReactNode;
	initialState?: {
		addedLineItem?: LineItemFragment;
		errorIsOpen?: boolean;
	};
}) => {
	const [addedLineItem, setAddedLineItem] = useState(initialState?.addedLineItem);
	const [errorIsOpen, setErrorOpen] = useState(initialState?.errorIsOpen ?? false);

	return (
		<AddToCartContext.Provider
			value={{
				addedLineItem,
				setAddedLineItem,
				errorIsOpen,
				setErrorOpen,
			}}
		>
			{children}
		</AddToCartContext.Provider>
	);
};

export const useAddToCartContext = () => useContext(AddToCartContext);
